
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/odysse-electric-vehicles",
      function () {
        return require("private-next-pages/case-study/odysse-electric-vehicles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/odysse-electric-vehicles"])
      });
    }
  